export const hasLinkedTradingProfile = (tradingProfileId: number | null | undefined): tradingProfileId is number =>
    typeof tradingProfileId === 'number' && tradingProfileId > 0;
